import { Context } from "react"
import { useContext } from "react"
import { CateringContextType } from "./catering-context"
import { CateringContext } from "./catering-context"

export const useCatering = () => {
  return useContext<CateringContextType>(
    CateringContext as Context<CateringContextType>
  )
}
